// extracted by mini-css-extract-plugin
export default {"nav_box":"index_nav_box_5fL5P","nav":"index_nav_NOU3X"};